(ns common.schema.entities.cached-value
  (:require [common.schema.schema-utils :as su]))

(def schema
  (vec (concat
        (su/keyword-field :cached-value/attribute "Related attribute" nil {:default-field-visibility :not-in-use-blocked
                                                                           :authorization            su/access-system-system
                                                                           :system-semantics         su/system-controlled-optional-field-semantics})
        (su/single-ref-field :cached-value/entity "Related entity" [] {:default-field-visibility :not-in-use-blocked
                                                                       :authorization            su/access-system-system
                                                                       :system-semantics         su/system-controlled-optional-field-semantics})
        (su/text-edn-field :cached-value/value "Cached value" {:default-field-visibility :not-in-use-blocked
                                                               :authorization            su/access-system-system
                                                               :system-semantics         su/system-controlled-optional-field-semantics}))))
